define("ember-arg-types/-private/throw-console-error", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@embroider/macros"eaimeta@70e063a35619d71f
  let throwConsoleError;
  {
    throwConsoleError = () => {
      throw new Error('throwConsoleError() is not available in production');
    };
  }
  var _default = _exports.default = throwConsoleError;
});